<template>

<svg  xmlns="http://www.w3.org/2000/svg" 
	  viewBox="-11.5 780.5 24 24" >
<path d="M10.468,792.449l-4.811-8.564c-0.045-0.08-0.129-0.129-0.221-0.129H-4.651c-0.194,0-0.315,0.208-0.22,0.377l4.666,8.252
	c0.044,0.078,0.043,0.175-0.002,0.252l-4.818,8.228c-0.099,0.168,0.023,0.38,0.218,0.38H5.285c0.089,0,0.172-0.047,0.218-0.124
	l4.963-8.419C10.511,792.624,10.512,792.527,10.468,792.449z"/>
<path d="M-5.967,786.217l-3.5,6.19c-0.044,0.078-0.043,0.174,0.002,0.252l3.5,5.976c0.13,0.223,0.471,0.131,0.471-0.127v-12.166
	C-5.494,786.081-5.839,785.99-5.967,786.217z"/>
</svg>

</template>